import { twMerge } from "tailwind-merge"
import { Row, TableBodyPropGetter, TableBodyProps } from "react-table"

import { useAppSelector } from "store/hooks"
import { BikeFleetType } from "features/bikeFleet/types/bikeFleetType"

type BodyTableBikeFleetProps = {
	getTableBodyProps: (propGetter?: TableBodyPropGetter<BikeFleetType>) => TableBodyProps
	page: Row<BikeFleetType>[]
	prepareRow: (row: Row<BikeFleetType>) => void
	getColumnSize: (val: string) => string
}

const BodyTableBikeFleet: React.FC<BodyTableBikeFleetProps> = ({
	getTableBodyProps,
	page,
	prepareRow,
	getColumnSize,
}) => {
	const selectedStatus = useAppSelector((state) => state.bikeFleet.currentBikeFleetStatusSelected)

	return (
		<tbody {...getTableBodyProps()}>
			{page.map((row) => {
				prepareRow(row)
				const isDisabled = selectedStatus && row.values.status !== selectedStatus
				return (
					<tr className="c-table__row" {...row.getRowProps()}>
						{row.cells.map((cell) => {
							return (
								<td
									className={twMerge(
										"py-5 box-border w-[100%] text-sm inline-block break-word px-2",
										getColumnSize(cell.column?.id),
										isDisabled &&
											"opacity-30 pointer-events-none cursor-not-allowed"
									)}
									{...cell.getCellProps()}
								>
									{cell.render("Cell")}
								</td>
							)
						})}
					</tr>
				)
			})}
		</tbody>
	)
}
export default BodyTableBikeFleet
